<script lang="ts">
  import BookmarkProjectList from "./BookmarkProjectList.svelte";
  import FeatherIcon from "svelte-feather-icon";
  import { Button, Card, Col, Container, Row } from "sveltestrap";
  import data from "../../../../Data/Project/Project.json";
  import ProjectListData from "./ProjectListData.svelte";
  import Link  from "svelte-link";
  import { CreateNewProject } from "../../../../utils/Constant/Constant";
  let temid:string = "top-home";
  const handleclick = (id:string) => {
    temid = id;
  };
</script>

<BookmarkProjectList />
<Container fluid>
  <Row class="project-cards">
    <Col md="12" class="project-list">
      <Card>
        <Row>
          <Col md="6">
            <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
              {#each data.projectlist as projectItem}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <li class="nav-item">
                  <Link
                    class="nav-link {temid === projectItem.id ? 'active' : ''}"
                    id={projectItem.id}
                    href={projectItem.link}
                    on:click={() => handleclick(projectItem.id)}
                  >
                    <FeatherIcon icon={projectItem.icon} />{projectItem.name}
                  </Link>
                </li>
              {/each}
            </ul>
          </Col>
          <Col md="6">
            <div class="form-group mb-0 me-0" />
            <Button color="primary" href="/project/createnew">
              <FeatherIcon icon="plus-square" /> {CreateNewProject}
            </Button> 
          </Col>
        </Row>
      </Card>
    </Col>
    <ProjectListData itemId={temid}/>
  </Row>
</Container>
